import CommentApi, { NewCommentData } from '../api/commentApi';
import CommentData from '../types/commentData';

export default class CommentService {
  public static async insertCommentInArray(newComment: NewCommentData, comments: CommentData[]) {
    const id = await CommentApi.addComment(newComment);
    const addedComment = await CommentApi.getComment(id);
    return [...comments, addedComment];
  }

  public static async upvoteCommentInArray(comment: CommentData, userId: string, comments: CommentData[]) {
    let updatedDownUuids = comment.downUuids.filter(uuid => uuid !== userId);

    let updatedUpUuids;
    if (comment.upUuids.includes(userId)) {
      updatedUpUuids = comment.upUuids.filter(uuid => uuid !== userId);
    } else {
      updatedUpUuids = [...comment.upUuids, userId];
    }
    const updatedComment = {
      ...comment,
      upUuids: updatedUpUuids,
      downUuids: updatedDownUuids,
    };
    await CommentApi.updateComment(updatedComment);
    return comments.map(comment => (comment.id === updatedComment.id ? updatedComment : comment));
  }

  public static async downvoteCommentInArray(comment: CommentData, userId: string, comments: CommentData[]) {
    let updatedUpUuids = comment.upUuids.filter(uuid => uuid !== userId);

    let updatedDownUuids;
    if (comment.downUuids.includes(userId)) {
      updatedDownUuids = comment.downUuids.filter(uuid => uuid !== userId);
    } else {
      updatedDownUuids = [...comment.downUuids, userId];
    }
    const updatedComment = {
      ...comment,
      downUuids: updatedDownUuids,
      upUuids: updatedUpUuids,
    };
    await CommentApi.updateComment(updatedComment);
    return comments.map(comment => (comment.id === updatedComment.id ? updatedComment : comment));
  }

  public static async editCommentBody(comment: CommentData, newBody: string) {
    const updatedComment: CommentData = {
      ...comment,
      body: newBody,
    };

    await CommentApi.updateComment(updatedComment);
  }

  public static async deleteComment(comment: CommentData, comments: CommentData[]): Promise<CommentData[]> {
    const deletedComment: CommentData = {
      ...comment,
      body: 'deleted comment',
      isDeleted: true,
    };

    await CommentApi.updateComment(deletedComment);
    return comments.map(comment => (comment.id === deletedComment.id ? deletedComment : comment));
  }
}
